export default {
  getEmissionsOfFilter: state => page => {
    let index = state.emissionsDataTable.findIndex(todo => todo.page === page);
    return index
  },
  getStatisticDashboardCsak: state => state.statisticDashboardCsak
}